// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./input.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).input;

// accented characters to accept since javascript \w doesnt accept these by default
var accentedCharacters = "àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ";
var specialCharacters = "\.\!#\$\^%()+\;,\/\{\}\|\?";
var moduleHelper = require('../../scripts/module-helper');

function parse(text, next) {

    // get the html for this module
    strip(require('raw!./input.html'), function(theOutputHtml) {
        // match starting with a word-character
        // followed by one or more word-chars, accented chars or special chars
        // followed by (maybe) : followed by word-chars and/or numbers
        // followed by (maybe) a asterisk
        // followed by (maybe) whitespace
        // followed by =
        // followed by (maybe) whitespace
        // followed by (maybe) bracket [
        // followed by exactly 3 or more underscores
        // followed by (maybe) bracket ]
        var parseRe = new RegExp("\\[([/\\w" + accentedCharacters + specialCharacters + "]{1}[/\\w\\-" + accentedCharacters + specialCharacters + " \\t]*)(?:\\:{1}([A-Za-z0-9]+)?)?(\\*?)\\s*=\\s*(\\[?)(_{3,})(\\]?)\\]", "g");

        var match = parseRe.exec(text);
        while (match != null) {
            var isTextArea = false;

            var container = document.createElement("div");
            container.innerHTML = theOutputHtml;
            var domObj = container.firstChild;

            var keyExtra = (typeof match[2] != 'undefined') ? ' data-keyextra="' + match[2] + '"' : '';

            var cleanedName = match[1].trim().replace(/\t/g, ' '); // label
            var inputName = cleanedName.replace(/[ \t]/g, '_').toLowerCase(); // name/id attribute

            var labelName = cleanedName;
            var output = '<label for="' + inputName + '">' + labelName + '</label>';

            if (match[4] == "[" && match[6] == "]") {
                isTextArea = true;
                var rows = match[5].length - 1;
                output += '<textarea rows="' + rows + '" name="' + inputName + '" id="' + inputName + '"' + keyExtra + '></textarea>';
            }
            else {
                output += '<input class="" type="text" name="' + inputName + '" id="' + inputName + '"' + keyExtra + '>';
            }
            output += '<div class="message"></div>';
            domObj.innerHTML = output;

            if (match[3] == "*") {
                domObj = container.firstChild;

                var input = (isTextArea) ? domObj.getElementsByTagName("textarea")[0] : domObj.getElementsByTagName("input")[0];
                input.setAttribute("data-required", "true");

                // add a "required" class to the parent node
                domObj.setAttribute("class", domObj.getAttribute("class") + " required");
            }

            outputHtml = container.innerHTML;

            text = text.replace(match[0], outputHtml);

            match = parseRe.exec(text);
        }

        next(text);
    });
};

function init(formRoot, meta, next){
    var allContexts = formRoot.querySelectorAll('[data-module="input"]');
    
    if( allContexts && allContexts.length ) {
        for(var i=0; i<allContexts.length; i++){
            moduleHelper.fields.text.bindValidationEvents(allContexts[i], validate);
        }
    }
    next(formRoot);
}

function validate(context) { 
    var input = context.getElementsByTagName("input")[0] || context.getElementsByTagName("textarea")[0];
    var value = input.value;
    var required = input.getAttribute("data-required") == "true";

    var validationResult = validation.validate(value, required);

    var currentClasses = input.getAttribute("class") || "";
    currentClasses = currentClasses.replace(/(|\s)valid(|\s)/g, "").replace(/(|\s)error(|\s)/g, "");

    if (!validationResult.valid) {
        input.setAttribute("class", currentClasses + " error");

    }
    else {
        input.setAttribute("class", currentClasses + " valid");   
    }

    return validationResult.valid;
}

function getDataKey(context) {
    // returns a dataKey for fields using this module directly
    var domInput = context.getElementsByTagName("input")[0] || context.getElementsByTagName("textarea")[0];
    var key = domInput.getAttribute("name");
    var keyExtra = domInput.getAttribute("data-keyextra");
    if (keyExtra) {
        key += "." + keyExtra;
    }
    return key;
}

function get(context) {
    var input = context.getElementsByTagName("input")[0] || context.getElementsByTagName("textarea")[0];
    return input.value;
}

function reset(context) {
    var input = context.getElementsByTagName("input")[0] || context.getElementsByTagName("textarea")[0];
    input.value = '';
}

module.exports = {
    parse: parse,
    validate: validate,
    getDataKey: getDataKey,
    get: get,
    init: init,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/input/input.js